import { render, staticRenderFns } from "./LanguageSelect.vue?vue&type=template&id=2ce319b2&scoped=true"
import script from "./LanguageSelect.vue?vue&type=script&lang=ts"
export * from "./LanguageSelect.vue?vue&type=script&lang=ts"
import style0 from "./LanguageSelect.vue?vue&type=style&index=0&id=2ce319b2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce319b2",
  null
  
)

export default component.exports